import { ExperienceQueryProvider } from "__legacy/queries/experiences/ExperienceQueryProvider";
import { UpdateExperienceMutationProvider } from "__legacy/queries/experiences/UpdateExperienceMutationProvider";
import { Button, Form, Layout, PageHeader } from "antd";
import { Fragment, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { ExperienceForm, onError, onFinish } from "./ExperienceForm";

export const Edit: React.FC<{}> = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [errors, setErrors] = useState<string[]>([]);

  return (
    <ExperienceQueryProvider variables={{ id: id }}>
      {({ experience }) => (
        <UpdateExperienceMutationProvider onError={onError(form, setErrors)} onCompleted={() => navigate("../../")}>
          {(loading, mutate) => (
            <Fragment>
              <PageHeader
                ghost={true}
                title={`Edit experience of ${experience.name} for ${experience.stakeholder.companyName}`}
                extra={
                  <Fragment>
                    <Button onClick={() => navigate("../../")}>Back to experiences</Button>
                    <Button type="primary" loading={loading} onClick={() => form.submit()}>
                      Save
                    </Button>
                  </Fragment>
                }
              />
              <Layout.Content className="content">
                <ExperienceForm
                  action="update"
                  form={form}
                  handler={onFinish(mutate, {}, { id })}
                  values={{
                    ...experience,
                    stakeholderId: experience.stakeholder.id,
                  }}
                  errors={errors}
                />
              </Layout.Content>
            </Fragment>
          )}
        </UpdateExperienceMutationProvider>
      )}
    </ExperienceQueryProvider>
  );
};
